// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "complaint-book-ms-" + ({"549":"app-book-presentation-pages-SelectCountry","723":"app-book-presentation-pages-Privacy"}[chunkId] || chunkId) + "-st-" + {"134":"72b75d14","462":"8fa39cc6","508":"42413895","549":"f27288e2","723":"2df46f10","874":"baf56a47"}[chunkId] + ".js";
};